import React from "react";
import { useSelector } from "react-redux";
import classNames from "classnames";
import { SocialVisibility } from "Services/API/API";
import { socialActivityEnabledSelector, socialVisibilitySelector } from "Utils/selectors";

export interface SocialVisibilityIndicatorProps {
   className?: string,
}
export interface SocialVisibilityIndicatorControlledProps extends SocialVisibilityIndicatorProps {
   socialVisibility: SocialVisibility
}

export const SocialVisibilityIndicator: React.FC<SocialVisibilityIndicatorProps> = ({ className }) => {
   const socialVisibility = useSelector(socialVisibilitySelector);
   const socialActivityEnabled = useSelector(socialActivityEnabledSelector);

   if(!socialActivityEnabled)
      return null;

   return <SocialVisibilityIndicatorControlled className={className} socialVisibility={socialVisibility} />
}

export const SocialVisibilityIndicatorControlled: React.FC<SocialVisibilityIndicatorControlledProps> = ({ className, socialVisibility }) => {
   return <div className={classNames("social-visibility-indicator", {
      "social-visibility-indicator--visible": socialVisibility == SocialVisibility.Visible,
      "social-visibility-indicator--invisible": socialVisibility == SocialVisibility.Invisible,
   }, className)} />
}